import { Controller } from '@hotwired/stimulus';

export class DisplayWhenCheckedController extends Controller {
  static targets = ['item'];
  static values = {
    multiple: {
      type: Boolean,
      default: false,
    },
    toggleOnConnect: {
      type: Boolean,
      default: true,
    },
  };

  connect() {
    if (!this.toggleOnConnectValue) return;

    [...this.element.querySelectorAll('[data-action~="display-when-checked#toggle"]:checked')].forEach(target => target.dispatchEvent(new Event('input')));
  }

  toggle(event) {
    if (this.itemTargets.length > 1 || this.multipleValue) {
      this.itemTargets.forEach(item => {
        if (item.dataset.value.split(' ').includes(event.target.value)) {
          item.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = false);
          item.classList.remove('hidden');
          return;
        }

        item.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = true);
        item.classList.add('hidden');
      });
      return;
    }

    if (event.target.checked) {
      this.itemTarget.classList.remove('hidden');
      this.itemTarget.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = false);
      return;
    }

    this.itemTarget.classList.add('hidden');
    this.itemTarget.querySelectorAll('input, textarea, select, button').forEach(el => el.disabled = true);
  }
}
